<script>
import ContentCover from "@/components/content/cover/ContentCover";
import ContentTabset from "@/components/content/tabset/ContentTabset";

export default {
  name: "BodyProducts",
  components: {
    ContentCover,
    ContentTabset
  }
};
</script>

<style lang="stylus" scoped>
@import "BodyProducts"
</style>
